export default "__VITE_ASSET__DSb5JLoX__"